import type { PropType } from 'virtual-vue';
import type { ActionSheetAction } from './action-sheet';
/**
 * 组件的props
 */
export const props = {
  /**
   * 是否显示弹出层
   * @default false
   */
  visible: {
    type: Boolean,
    default: false,
  },
  /**
   * 面板选项列表
   * @default []
   */
  actions: {
    type: Array as PropType<ActionSheetAction[]>,
    default: () => [],
  },
  /**
   * 动作面板顶部标题
   * @default ''
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * 取消按钮文案
   * @default '取消'
   */
  cancelText: {
    type: String,
    default: '取消',
  },
};
